import {ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import { EntityDataLayoutService } from "./entity-data-layout.service";
import {distinctUntilChanged, map } from 'rxjs';

@Component({
    changeDetection: ChangeDetectionStrategy.OnPush,
    selector: 'entity-data-layout',
    templateUrl: './entity-data-layout.component.html',
    standalone: false
})
export class EntityDataLayoutComponent {

  readonly viewName$ = this.entityDataLayoutService.ViewName$;
  readonly entityKey$ = this.entityDataLayoutService.EntityKey$;
  readonly dashboardTitle$ = this.entityDataLayoutService.DashboardTitle$;
  readonly ref$ = this.entityDataLayoutService.Ref$;
  readonly maximisedWidget$ = this.entityDataLayoutService.MaximisedWidget$;
  readonly routeContextTypeName$ = this.entityDataLayoutService.ActivatedRoute$.pipe(
    map(route => route.snapshot?.data?.routeContext?.kind),
    distinctUntilChanged()
  );

  constructor(
    private readonly entityDataLayoutService: EntityDataLayoutService) {
  }

}
